<div class="site-page-header-ghost-wrapper">
    <nz-page-header nzBackIcon [nzGhost]="false">
        <nz-page-header-title>Importações</nz-page-header-title>
        <nz-page-header-subtitle class="hide-xs"> - Lista de arquivos do importados.</nz-page-header-subtitle>
    </nz-page-header>
    <div nz-row [nzGutter]="12">
        <div nz-col nzMd="24" nzXs="24" style="margin-bottom: 20px;">
            <form nz-form nzLayout="inline">
                <div nz-col nzMd="5" nzXs="12">
                    <nz-form-label>Data Inicial</nz-form-label>
                    <nz-form-item>
                        <nz-form-control nzHasFeedback nzErrorTip="Data Inválida!">
                            <input nz-input type="date" name="pesquisaDataInicial" [(ngModel)]="pesquisaDataInicial"
                                placeholder="00/00/0000" />
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzMd="5" nzXs="12">
                    <nz-form-label>Data Final</nz-form-label>
                    <nz-form-item>
                        <nz-form-control nzHasFeedback nzErrorTip="Data Inválida!">
                            <input nz-input type="date" name="pesquisaDataFinal" [(ngModel)]="pesquisaDataFinal"
                                placeholder="00/00/0000" />
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzMd="5" nzXs="24">
                    <p style="color:white; margin-bottom: 10px!important;">-</p>
                    <button nz-button nzType="primary" (click)="pesquisar()" nzBlock nzSearch>Pesquisar</button>
                </div>
                <div nz-col nzMd="5" nzXs="24">
                    <p style="color:white; margin-bottom: 10px!important;">-</p>
                    <button nz-button nzType="default" [disabled]="!pesquisaDataFinal" (click)="cancelarPesquisa()"
                        nzBlock nzSearch style="color:#c0392b;">Cancelar Pesquisa</button>
                </div>
            </form>
        </div>

        <div nz-col nzMd="24" nzXs="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="importacoes"
                [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize"
                [nzPageIndex]="pageIndex">
                <thead>
                    <tr>
                        <th class="hide-xs">#</th>
                        <th class="hide-xs">Data</th>
                        <th>Nome Original</th>
                        <th class="hide-xs" style="text-align: center;">Resultado</th>

                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td class="hide-xs">
                                <span>
                                    <nz-badge *ngIf="data.status === 1" nzStatus="processing" nz-tooltip
                                        nzTooltipTitle="Processando..."></nz-badge>
                                    <nz-badge *ngIf="data.status === 2" nzStatus="success" nz-tooltip
                                        nzTooltipTitle="Concluído"></nz-badge>
                                    <nz-badge *ngIf="data.status === 3" nzStatus="warning" nz-tooltip
                                        nzTooltipTitle="Falha em alguns registros"></nz-badge>
                                    {{ data.idxlsx_medicamento_importacao }}
                                </span>
                            </td>
                            <td class="hide-xs">
                                <span> {{ data.created_at | date: 'dd/MM/yyyy H:mm:ss' }}</span>
                            </td>
                            <td>
                                {{data.original_nome}}
                            </td>
                            <td class="hide-xs" style="text-align: center;">
                                <nz-tag nzColor="success" nz-tooltip nzTooltipTitle="Registros Criados">
                                    <i nz-icon nzType="check-circle"></i>
                                    <span>{{data.registros_criados}}</span>
                                </nz-tag>
                                <nz-tag nzColor="processing" nz-tooltip nzTooltipTitle="Registros Atualizados">
                                    <i nz-icon nzType="sync" nzTheme="outline"></i>
                                    <span>{{data.registros_atualizados}}</span>
                                </nz-tag>
                                <nz-tag nzColor="error" nz-tooltip nzTooltipTitle="Registros com Falhas">
                                    <i nz-icon nzType="exclamation-circle"></i>
                                    <span>{{data.registros_erro}}</span>
                                </nz-tag>
                            </td>

                            <td>
                                <button nz-button (click)="reimportar(data.idxlsx_medicamento_importacao)"
                                    [disabled]="data.registros_erro === 0"><i nz-icon nzType="undo"
                                        nzTheme="outline"></i> Reimportar</button>

                                <button nz-button nz-dropdown [nzDropdownMenu]="menu1" nzPlacement="bottomRight"
                                    [disabled]="data.registros_erro === 0">
                                    <i nz-icon nzType="ellipsis"></i>
                                </button>
                                <nz-dropdown-menu #menu1="nzDropdownMenu">
                                    <ul nz-menu>
                                        <li nz-menu-item *ngIf="data.registros_erro > 0"
                                            (click)="showModalFalhas(data.idxlsx_medicamento_importacao)">Ver Falhas
                                        </li>
                                    </ul>
                                </nz-dropdown-menu>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>

    <nz-modal nzWidth="910" [(nzVisible)]="isVisibleModalDetalhe" nzTitle="Falhas na Importação"
        (nzOnCancel)="cancelModalFalhas()" [nzOkDisabled]="true">
        <ng-container *nzModalContent>
            <nz-table #table nzSize="small" (nzQueryParams)="onQueryParamsChangeFalha($event)"
                [(nzData)]="infoDetalharFalhas" [nzFrontPagination]="false" [nzLoading]="loadingFalhas"
                [nzTotal]="totalFalhas" [nzPageSize]="pageSizeFalhas" [nzPageIndex]="pageIndexFalhas">
                <thead>
                    <tr>
                        <th style="text-align:center;">Falhas</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="table.data">
                        <tr>
                            <td> <i nz-icon style="color:#c0392b;" nzType="warning" nzTheme="outline"></i> {{data.msg}}.
                            </td>

                        </tr>
                    </ng-template>
                </tbody>
            </nz-table>
        </ng-container>
        <div *nzModalFooter>

        </div>
    </nz-modal>